<template>
  <ul>
    <li v-for="(criteriaItem, criteriaIndex) in rubric.criteria">
      <span v-if="rubric.criteria.length > 1">{{ criteriaItem.name }}</span>
      <ratings :range="rubric.scoreRange" v-model="value[criteriaIndex]" :read-only="true" :stars="rubric.criteria.length == 1" />
    </li>
  </ul>
</template>

<script>

  export default {
    name: 'RubricCriteria',
    props: {
      value: {},
      rubric: {
        type: Object,
        required: true
      }
    }
  }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  @import "~globals";

  ul {
    @include list-style-reset;
  }

  li {
    display:flex; margin-top:2rem;
    &:first-child {
      margin-top:0;
    }
  }

  span {
    @include font-size(small);
    flex:2; margin-right:2rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/rubric-criteria.vue